(function () {
  const CONTAINER = '.multicolumnmain';
  const svgString = `
    <svg enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg">
      <path d="m81.115 45.133-.997 1.734 3.541 2.035-71.04-.001v2l71.491.001-3.761 2.557 1.125 1.654 7.79-5.297z"></path>
    </svg>
  `;

  function createSvgElement(isPrev) {
    const doc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
    const svg = doc.documentElement;

    // remove id to avoid duplicates if multiple arrows are inserted
    svg.removeAttribute('id');

    // accessibility + ignore keyboard focus
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');

    // flip the prev arrow horizontally
    if (isPrev) {
      svg.style.transform = 'scaleX(-1)';
      svg.style.transformOrigin = '50% 50%';
      // keep it block so it aligns like the original
      svg.style.display = 'block';
    }

    return svg;
  }

  function replaceArrows() {
    const root = document.querySelector(CONTAINER);
    if (!root) return false;
    const buttons = root.querySelectorAll('.splide__arrow');
    let changed = false;

    buttons.forEach(btn => {
      // mark so we don't re-insert repeatedly
      if (btn.dataset.customSvgInserted === '1') return;

      // remove any existing inline svg(s)
      btn.querySelectorAll('svg').forEach(s => s.remove());

      // create and append new svg (flip if it's the prev button)
      const svg = createSvgElement(btn.classList.contains('splide__arrow--prev'));
      btn.appendChild(svg);

      btn.dataset.customSvgInserted = '1';
      changed = true;
    });

    return changed;
  }

  // Run once now (if arrows already present)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceArrows);
  } else {
    replaceArrows();
  }

  // MutationObserver: watch for arrows being added/replaced by the slider later
  const observeTarget = document.querySelector(CONTAINER) || document.body;
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length === 0) continue;
      // If nodes that look like arrows were added somewhere in subtree, try replacement
      if (Array.from(m.addedNodes).some(n => {
        if (n.nodeType !== 1) return false;
        return n.matches && (n.matches('.splide__arrow') || n.matches('.splide__arrows') || n.querySelector && n.querySelector('.splide__arrow'));
      })) {
        replaceArrows();
        // no break: continue checking other mutations
      }
    }
  });
  observer.observe(observeTarget, { childList: true, subtree: true });

  // Splide hook (if a Splide instance exists on the element, attach to its 'mounted' event)
  try {
    document.querySelectorAll('.splide').forEach(el => {
      if (el && el.splide && typeof el.splide.on === 'function') {
        el.splide.on('mounted', replaceArrows);
      }
    });
  } catch (e) {
    // ignore if Splide instance not exposed
  }

  // Poll fallback (tries a few times in case of late initialization)
  let tries = 0;
  const poll = setInterval(() => {
    if (replaceArrows() || ++tries > 30) clearInterval(poll);
  }, 200);
})();
